module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_lg_04.78ca6dd9.jpg";